import {addFunc} from "../functions/Mathematik";

export function CalcMaydon(maydon,cropids){
    var maydonsum = {};
    Object.keys(maydon).map(ist=>{
        Object.keys(maydon[ist]).map(g=>{
            Object.keys(maydon[ist][g]).map(k=>{
                if(cropids.includes(k.slice(1))){
                    if(!maydonsum[ist]){
                        maydonsum[ist] = {};
                    }
                    maydonsum[ist][k] = addFunc(maydonsum[ist][k],maydon[ist][g][k])
                }
            })
        })
    })
    return maydonsum
}
export function CalcMaydonByTartib(maydon,cropids,tartiblar){
    var maydonsum = {};
    Object.keys(maydon).map(ist=>{
        Object.keys(maydon[ist]).map(g=>{
            Object.keys(maydon[ist][g]).map(k=>{
                if(cropids.includes(k.slice(1))){
                    if(!maydonsum[ist]){
                        maydonsum[ist] = {};
                    }
                    let m = maydon[ist][g][k]
                    if(tartiblar[g.slice(1)+"_"+k.slice(1)]){
                        m = m * tartiblar[g.slice(1)+"_"+k.slice(1)]
                    }
                    maydonsum[ist][k] = addFunc(maydonsum[ist][k],m)
                }
            })
        })
    })
    return maydonsum
}
export default function decade_days(season,year){
    if(season == 'veg'){
        return {
            d1:10,
            d2:10,
            d3:10,
            d4:10,
            d5:10,
            d6:11,
            d7:10,
            d8:10,
            d9:10,
            d10:10,
            d11:10,
            d12:11,
            d13:10,
            d14:10,
            d15:11,
            d16:10,
            d17:10,
            d18:10,
        }
    }else{
        return {
            d1:10,
            d2:10,
            d3:11,
            d4:10,
            d5:10,
            d6:10,
            d7:10,
            d8:10,
            d9:11,
            d10:10,
            d11:10,
            d12:11,
            d13:10,
            d14:10,
            d15:(year%4==0)?9:8,
            d16:10,
            d17:10,
            d18:11,
        }
    }
}
export function season_month(season){
    if(season == 'noveg'){
        return ["Oktyabr","Noyabr","Dekabr","Yanvar","Fevral","Mart"]
    }else{
        return ["Aprel","May","Iyun","Iyul","Avgust","Sentyabr"]
    }
}
export function gmslar(maydon,cropids, jami=false){
    let jami_maydon = 0
    let gmlar = {}
    Object.keys(maydon).map(ist=>{
        Object.keys(maydon[ist]).map(g=>{
            Object.keys(maydon[ist][g]).map(k=>{
                if(cropids.includes(k.slice(1))){
                    if(!gmlar[g]){
                        gmlar[g] = {};
                    }
                    gmlar[g][k] = addFunc(gmlar[g][k],maydon[ist][g][k])
                    jami_maydon = addFunc(jami_maydon,maydon[ist][g][k])
                }
            })
        })
    })
    if(jami){
        return [gmlar,jami_maydon]
    }
    return gmlar;
}